import React, { useState } from 'react';
import '../../css/onboardingFirstSteps.css';
import { useMobileMediaQuery, useTabletMediaQuery, useUltraMobileMediaQuery } from '../../utils';
import OnboardingStepOne from './OnboardingStepOne';
import OnboardingStepTwo from './OnboardingStepTwo';
import OnboardingStepThree from './OnboardingStepThree';
import OnboardingStepFour from './OnboardingStepFour';
import imgStepOne from '../../assets/img/onboarding/desktop/img-ativar-carteira.jpg';
import imgStepOneTablet from '../../assets/img/onboarding/tablet/img-ativar-carteira.jpg';
import imgStepOneMobile from '../../assets/img/onboarding/mobile/img-ativar-carteira.jpg';
import imgStepTwo from '../../assets/img/onboarding/desktop/img-associar-cartao.jpg';
import imgStepTwoTablet from '../../assets/img/onboarding/tablet/img-associar-cartao.jpg';
import imgStepTwoMobile from '../../assets/img/onboarding/mobile/img-associar-cartao.jpg';
import imgStepThree from '../../assets/img/onboarding/desktop/img-como-usar-carteira.jpg';
import imgStepThreeTablet from '../../assets/img/onboarding/tablet/img-como-usar-carteira.jpg';
import imgStepThreeMobile from '../../assets/img/onboarding/mobile/img-como-usar-carteira.jpg';
import imgStepFour from '../../assets/img/onboarding/desktop/img-aceitar-termos.jpg';
import imgStepFourTablet from '../../assets/img/onboarding/tablet/img-aceitar-termos.jpg';
import imgStepFourMobile from '../../assets/img/onboarding/mobile/img-aceitar-termos.jpg';

function OnboardingSteps() {

  const [currentPage, setCurrentPage] = useState(1);
  const isMobile = useMobileMediaQuery();
  const isTablet = useTabletMediaQuery();
  const isUltraMobile = useUltraMobileMediaQuery();

  const handleOnClickSaltarNavigate = () => {
    const skipPages = 4 - currentPage;
    setCurrentPage((prevPage) => prevPage < 4 ? prevPage + skipPages : prevPage);
  };
  const handleOnClickNavigate = () => {
    setCurrentPage((prevPage) => prevPage < 4 ? prevPage + 1 : prevPage);
  };

  const handleOnClickBackNavigate = () => {
    setCurrentPage((prevPage) => prevPage <= 4 ? prevPage - 1 : prevPage);
  };

  const renderCurrentStep = () => {
    switch (currentPage) {
      case 1:
        return <OnboardingStepOne onNext={handleOnClickNavigate} onSkip={handleOnClickSaltarNavigate} mainImgSvg={isTablet ? imgStepOne : (isMobile ? imgStepOneTablet : (isUltraMobile ? imgStepOneTablet : imgStepOneMobile))} />;
      case 2:
        return <OnboardingStepTwo onNext={handleOnClickNavigate} onPrev={handleOnClickBackNavigate} onSkip={handleOnClickSaltarNavigate} mainImgSvg={isTablet ? imgStepTwo : (isMobile ? imgStepTwoTablet : (isUltraMobile ? imgStepTwoTablet : imgStepTwoMobile))} />;
      case 3:
        return <OnboardingStepThree onNext={handleOnClickNavigate} onPrev={handleOnClickBackNavigate} onSkip={handleOnClickSaltarNavigate} mainImgSvg={isTablet ? imgStepThree : (isMobile ? imgStepThreeTablet : (isUltraMobile ? imgStepThreeTablet : imgStepThreeMobile))} />;
      case 4:
        return <OnboardingStepFour onPrev={handleOnClickBackNavigate} mainImgSvg={isTablet ? imgStepFour : (isMobile ? imgStepFourTablet : (isUltraMobile ? imgStepFourTablet : imgStepFourMobile))} />;
      default:
        return <OnboardingStepOne onNext={handleOnClickNavigate} onSkip={handleOnClickSaltarNavigate} mainImgSvg={isTablet ? imgStepOne : (isMobile ? imgStepOneTablet : (isUltraMobile ? imgStepOneTablet : imgStepOneMobile))} />;
    }
  };


  return (
    <>
      {renderCurrentStep()}
    </>
  )
}

export default OnboardingSteps;